import { z } from "zod";
import {
    UrlSearchParamsSchema,
    type UrlSearchParams,
} from "@/features/discovery/index.contract.ts";

export const DiscoverySearchSchema = UrlSearchParamsSchema.extend({
    dogId: z.string().optional(),
    demo: z.coerce.boolean().optional(),
    heroId: z.string().optional(),
});

export type DiscoverySearch = UrlSearchParams & {
    dogId?: string;
    demo?: boolean;
    heroId?: string;
};
